import React, { useEffect, useState } from 'react'
import houseServices from '../../services/HousesService'
import Loading from '../feedback/Loading'
import FetchError from '../feedback/FetchError'
import EmptyList from '../feedback/EmptyList'
import { LuArrowRight } from "react-icons/lu";
import HomeHouseItem from './HomeHouseItem'

function HousesList() {
    const [houses, setHouses] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()

    useEffect(() => {
        setError()
        houseServices.getHouses('').then(
            res => {
                setHouses(res.data)
                setLoading(false)
            },
            err => {
                setError(err)
                setLoading(false)
            }
        )
    }, [])
    useEffect(() => { }, [houses])
    useEffect(() => { }, [loading])
    useEffect(() => { }, [error])
    return (
        <div className='py-16  bg-surface-container-low '>
            <div className="container mx-auto px-3">
                <div className="flex justify-between items-end mb-12">
                    <div>
                        <h2 className="text-3xl font-black font-headline text-on-surface mb-2">
                            Featured House Plans
                        </h2>
                        <p className="text-on-surface-variant">
                            Browse our most popular ready-to-build architectural designs.
                        </p>
                    </div>

                    <button className="hidden md:flex items-center gap-2 text-primary font-bold hover:gap-3 transition-all group">
                        View All Plans
                        <LuArrowRight className="text-xl transition-transform" />
                    </button>
                </div>
                {loading ? (
                    <Loading />
                ) : (
                    <div>
                        {error ? (
                            <FetchError error={error} />
                        ) : (
                            <div>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                                    {houses?.results?.map((house, idx) => (
                                        <HomeHouseItem
                                            key={idx}
                                            house={house}
                                        />
                                    ))}
                                </div>
                                {houses && (
                                    <div>
                                        {houses?.results?.length < 1 && (
                                            <EmptyList item={"House List"} />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default HousesList